module.exports = __webpack_public_path__ + "static/media/sam.8c3fc3b9.svg";